export default [
  {
    title: "Product Development",
    description:
      "	We provide product development and RnD support with prototyping and mass production. We have a team of well skilled engineers for RnD in mechanical, electronics and software programming sections. Please contact our helpline or pay us a visit for more detailed information about our product development service, pricing and others.",
    notice: "",
  },
];
